type UXWizzTracker = {
  s: number;
  addTag: (tag: string) => void;
  addEvent: (tag: string) => void;
  trackNewPage?: () => void;
};

type UXWizzWindow = Window & {
  UST_CT?: string[];
  UST?: UXWizzTracker;
};

const UXWIZZ_SCRIPT_ID = "uxwizz-tracker";
const DEFAULT_ALLOWED_HOSTS = ["testreact.tradeasy.tech"];
const DEFAULT_EXCLUDED_EMAILS = ["josepm@tradeasy.tech"];

function parseList(value?: string) {
  return (value || "")
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean);
}

function isAllowedHost(hostname: string) {
  const configuredHosts = parseList(process.env.REACT_APP_UXWIZZ_ALLOWED_HOSTS);
  const allowedHosts = configuredHosts.length
    ? configuredHosts
    : DEFAULT_ALLOWED_HOSTS;

  return allowedHosts.includes(hostname);
}

function getCurrentUserEmail() {
  return (window.localStorage.getItem("user_email") || "")
    .trim()
    .toLowerCase();
}

function isAuthenticatedUser() {
  return Boolean(window.localStorage.getItem("user_id"));
}

function isExcludedUser() {
  const configuredEmails = parseList(
    process.env.REACT_APP_UXWIZZ_EXCLUDED_EMAILS
  ).map((email) => email.toLowerCase());
  const excludedEmails = configuredEmails.length
    ? configuredEmails
    : DEFAULT_EXCLUDED_EMAILS;
  const currentEmail = getCurrentUserEmail();

  return Boolean(currentEmail) && excludedEmails.includes(currentEmail);
}

export function shouldLoadUXWizz() {
  if (typeof window === "undefined") return false;
  if (process.env.REACT_APP_UXWIZZ_ENABLED !== "true") return false;
  if (!isAuthenticatedUser()) return false;
  if (isExcludedUser()) return false;

  return isAllowedHost(window.location.hostname);
}

export function loadUXWizz() {
  if (!shouldLoadUXWizz()) return false;
  if (document.getElementById(UXWIZZ_SCRIPT_ID)) return true;

  const trackerUrl = process.env.REACT_APP_UXWIZZ_TRACKER_URL;
  if (!trackerUrl) return false;

  const win = window as UXWizzWindow;
  win.UST_CT = win.UST_CT || [];

  if (!win.UST) {
    const addTag = (tag: string) => {
      win.UST_CT?.push(tag);
    };

    win.UST = {
      s: Date.now(),
      addTag,
      addEvent: addTag,
    };
  } else if (!win.UST.addEvent) {
    win.UST.addEvent = win.UST.addTag;
  }

  const script = document.createElement("script");
  script.id = UXWIZZ_SCRIPT_ID;
  script.src = trackerUrl;
  script.async = true;
  document.head.appendChild(script);

  return true;
}

export function trackUXWizzPageView() {
  if (!shouldLoadUXWizz()) return;

  const win = window as UXWizzWindow;
  win.UST?.trackNewPage?.();
}
